export default __webpack_public_path__ + "static/media/mba-logo.0533b71a.svg";